export default (state, action) => {
    switch (action.type) {
        case 'SET_CHAT_STATUS':
            return action.data;
        default:
            return typeof state === 'undefined' ? true : state;
    }
};
